/**
 * The AES-256-GCM wire contract, SHARED by every implementation (server `node:crypto`, web Web Crypto,
 * Android Crypto.kt mirrors these same values). Kept platform-neutral so both TS impls import the exact
 * same constants — the key-derivation salt and byte layout can never drift between server and web.
 *
 * Wire format: `base64( iv(IV_LEN) || ciphertext || tag(TAG_LEN) )`.
 */

/** Key derivation: 32-byte AES key = SHA-256(`${KEY_SALT_PREFIX}${pairingSecret}`). MUST match Crypto.kt. */
export const KEY_SALT_PREFIX = "callcenter-enc:v1:";
export const IV_LEN = 12;
export const TAG_LEN = 16;
/** Minimum ciphertext byte length (iv + tag, empty plaintext). */
export const MIN_LEN = IV_LEN + TAG_LEN;
